import { useRef } from "react";
import cx from "classnames";
import Column from "../../../components/Column";
import { PriceBreakdown } from "@ww-digital/web-palette-react/dist/components/Price/PriceBreakdown/PriceBreakdown";
import { Popup } from "@ww-digital/web-palette-react/dist/components/Popup/Popup/Popup";
import getPricebreakdown from "../../../utils/getPricebreakdown";
import t, { AsHtml } from "../../../utils/translate";
import styles from "./styles.module.scss";
import tag from "../../../styles/imgs/tag.svg";
import info from "../../../styles/imgs/info.svg";

const PricingCard = ({ plan, selected }) => {
  const { contentMap, salesPitch, offerPlanName } = plan;
  const PriceBreakdownProps = getPricebreakdown(plan);
  const popupComponent = useRef(null);
  const specialOffer = contentMap.get("SPECIAL_OFFER");
  const promotionContent = contentMap.get("PROMOTION_CONTENT");

  const togglePopup = () => {
    popupComponent?.current?.togglePopup();
  };

  return (
    <Column className={cx(styles.pricingCard, { [styles.selected]: selected })}>
      {salesPitch && (
        <p className={styles.banner}>
          <img className={styles.tag} aria-label="tag icon" src={tag} alt="" />
          {salesPitch}
        </p>
      )}
      <div className={cx(styles.grayArea, { [styles.noBanner]: !salesPitch })}>
        <h3 className={styles.planName}>
          <AsHtml value={offerPlanName} />
        </h3>
        {specialOffer && (
          <span className={styles.specialOffer}>{specialOffer}</span>
        )}
        <Popup
          ref={popupComponent}
          config={{
            position: "auto",
            offset: 10,
            hideClose: false
          }}
          clickOutsideDeactivates={true}
          handle={
            <img
              role="button"
              onClick={togglePopup}
              className={styles.info}
              aria-label="info icon button"
              src={info}
            ></img>
          }
        >
          <AsHtml
            className={styles.specialOffer}
            value={promotionContent}
            tagType="p"
          />
        </Popup>
      </div>
      <h4 className={styles.offerDetails}>{t("UNI_PRICING_OFFER_DETAILS")}</h4>
      <PriceBreakdown {...PriceBreakdownProps} />
    </Column>
  );
};

export default PricingCard;
